import React from "react";
import { Button, Tooltip } from "@mui/material";
import { Download, Refresh, ReplayTwoTone, UploadFile, Add, Cloud, PetsOutlined} from "@mui/icons-material";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

export default function MenuDrawer(props) {
    return(
        <div>
        {/* <Button onClick={props.update}><Refresh/></Button>
        <p/> */}
        <Tooltip title={"Undo"} placement="right">
           <Button variant="contained" onClick={() => {
              props.undo()
           }}><ReplayTwoTone/></Button>
        </Tooltip>
        <p/>
        <Tooltip title={"Load File..."} placement="right">
            <Button variant="contained" onClick={props.loadFile}><UploadFile/></Button>
        </Tooltip>
        <p/>
        <Tooltip title={"Save File..."} placement="right">
            <Button variant="contained" onClick={props.saveFile}><Download/></Button>
        </Tooltip>
        <p/>
        <Tooltip title={"Add"} placement="right">
            <Button onClick={props.addItem} variant="contained"><Add/></Button>
        </Tooltip>
        <p/>
        <Tooltip title = {"Cloud Dialog"} placement="right">
            <Button onClick={props.openCloudDialog} variant="contained"><Cloud/></Button>
        </Tooltip>
        <p/>
        <Tooltip title = {"Get Present"} placement="right">
            <Button variant="contained" onClick={props.openDogDialog}><PetsOutlined/></Button>
        </Tooltip>
        <p/>
        <Tooltip title = {"Scribble Card"} placement="right">
            <Button variant="contained" onClick={props.openScribbleCardDialog}><FavoriteBorderIcon/></Button>
        </Tooltip>
        </div>

    )
}